import {makeAutoObservable} from 'mobx';
import GradebookRepository from '../../../../../data/repositories/GradebookRepository';
import {toast} from 'react-toastify';
import {getErrorFromCode} from '../../../../../data/errorCodes';
import {toastConfig} from '../../../../../uiToolkit/Toast/toastConfig';

class CourseAnalyticsLearnersStore {
  private gradebookRepo = new GradebookRepository();

  constructor() {
    makeAutoObservable(this);
  }

  public async getCourseLearnersData(organizationId: string, courseId: string) {
    const result = await this.gradebookRepo.getCourseLearnersAnalytics(
      organizationId,
      courseId,
    );
    if (result.success && result.data) {
      return result.data;
    } else if (result.errors && result.errors[0]) {
      toast.error(getErrorFromCode(result.errors[0]), toastConfig);
      return [];
    }
    return [];
  }

  public async getCourseLearnerAnalyticsDetails(
    organizationId: string,
    courseId: string,
    learnerId: string,
  ) {
    const result = await this.gradebookRepo.getCourseLearnerAnalyticsDetails(
      organizationId,
      courseId,
      learnerId,
    );
    if (result.success && result.data) {
      return result.data;
    } else if (result.errors && result.errors[0]) {
      toast.error(getErrorFromCode(result.errors[0]), toastConfig);
    }
  }

  public async changeLessonGrade(
    organizationId: string,
    courseId: string,
    learnerId: string,
    lessonId: string,
    newGrade: number,
  ) {
    const result = await this.gradebookRepo.changeLearnerLessonGrade(
      organizationId,
      courseId,
      learnerId,
      lessonId,
      newGrade,
    );
    if (result.success) {
      return true;
    } else if (result.errors && result.errors[0]) {
      toast.error(getErrorFromCode(result.errors[0]), toastConfig);
    }
    return false;
  }
}

export default CourseAnalyticsLearnersStore;
